import React from 'react';

interface IcoBattleProps {
    size?: number;
}

export const IcoBattle: React.FC<IcoBattleProps> = ({ size = 35 }) => {
    const wrapperStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: `${size}px`,
        height: `${size}px`,
    };

    return (
        <div style={wrapperStyle}>
            <svg className="ico" width={size} height={size} viewBox="0 0 35 35" xmlns="http://www.w3.org/2000/svg">
                <g fill="none">
                    <path
                        fill="#7E8487"
                        d="M6.613 18.781 18.02 6.105a2.663 2.663 0 0 1 1.458-.83l3.839-.768a1.334 1.334 0 0 1 1.57 1.569l-.769 3.837a2.663 2.663 0 0 1-.83 1.459l-12.676 11.41-4-4z"
                    />
                    <path
                        fill="#F1F1F1"
                        d="m11.36 23.367-5.333-5.334A1.999 1.999 0 1 0 3.2 20.861l1.252 1.254L1.866 24.7a1.999 1.999 0 0 0 1.413 3.415c.512 0 1.024-.195 1.415-.586l2.585-2.586 1.252 1.252c.391.392.903.586 1.415.586s1.024-.194 1.415-.585c.78-.781.78-2.048 0-2.83z"
                    />
                    <path
                        fill="#7E8487"
                        d="m29.983 24.7-2.585-2.585 1.252-1.252a1.999 1.999 0 1 0-2.828-2.828l-5.333 5.333a1.999 1.999 0 1 0 2.829 2.828l1.252-1.252 2.585 2.585c.391.391.903.586 1.415.586s1.024-.195 1.415-.586c.78-.781.78-2.048-.002-2.829z"
                    />
                    <path
                        fill="#F1F1F1"
                        d="M25.16 18.696 13.826 6.106a2.659 2.659 0 0 0-1.458-.831L8.53 4.507a1.334 1.334 0 0 0-1.569 1.569l.768 3.839c.112.562.404 1.074.83 1.458L21.15 22.705l4.008-4.009z"
                    />
                </g>
            </svg>
        </div>
    );
};
